/** @format */
import { largeTablet } from '@mpb-com/feather/helpers/media-queries';
import styled, { css } from 'styled-components';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
/* eslint-disable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
export const StyledContentAccordionGroup = styled('div')`
    display: grid;
    gap: 16px;
    grid-template-columns: 1fr 1fr;

    ${largeTablet(css`
        grid-template-columns: 1fr;
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens, @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
